import Vue from "vue";
import VueRouter from "vue-router";
import Modulos from "../services/modulos";
Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Login",
    component: () => import("../views/Login.vue"),
  },
  {
    path: "/digitrack",
    name: "Principal",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Principal.vue"),
    children: [
      {
        path: "solicitudes",
        name: "Solicitudes",
        component: () => import("../views/Solicitudes.vue"),
      },
      {
        path: "nueva-muestra/:citaPersonaId?",
        name: "Nueva Muestra",
        component: () => import("../views/NuevaMuestra.vue"),
      },
      {
        path: "citas",
        name: "Citas",
        component: () => import("../views/citas/Citas.vue"),
      },
      {
        path: "sucursaldao",
        name: "Sucursal DAO",
        component: () => import("../views/citas/SucursalDAO.vue"),
      },
      {
        path: "recepciondao",
        name: "Recepcion DAO",
        component: () => import("../views/citas/RecepcionDAO.vue"),
      },
      {
        path: "toma-de-muestra",
        name: "Toma de Muestra",
        component: () => import("../views/citas/Citas.vue"),
      },
      {
        path: "nueva-cita",
        name: "Nueva Cita",
        component: () => import("../views/citas/NuevaCita.vue"),
      },
      {
        path: "info-cita/:citaId",
        name: "Ver Cita",
        component: () => import("../views/citas/NuevaCita.vue"),
      },
      {
        path: "carga-gradillas",
        name: "Cargar Gradillas",
        component: () => import("../views/lab/CargaGradillas.vue"),
      },
      {
        path: "info-muestra/:muestraId",
        name: "Ver Muestra",
        component: () => import("../views/NuevaMuestra.vue"),
      },
      {
        path: "certificados",
        name: "Certificados",
        component: () => import("../views/certificados/Certificados.vue"),
      },
      {
        path: "administracion",
        name: "Administración",
        component: () => import("../views/certificados/Administracion.vue"),
      },
      {
        path: "generacion-dao",
        name: "Laboratorio DAO",
        component: () => import("../views/lab/LaboratorioDAO.vue"),
      },
      {
        path: "laboratorio/:tab?",
        name: "Laboratorio",
        component: () => import("../views/lab/Laboratorio.vue"),
      },
      {
        path: "extraccion-gradillas/:codigoGradilla?",
        name: "Extraer Gradillas",
        component: () => import("../views/lab/CargaGradillas.vue"),
      },
      {
        path: "pre-pcr/:codigoGradilla?",
        name: "Pre PCR",
        component: () => import("../views/lab/CargaGradillas.vue"),
      },
      {
        path: "ver-gradillas/:codigoGradilla?",
        name: "Gradilla",
        component: () => import("../views/lab/CargaGradillas.vue"),
      },
      {
        path: "pcr/:pcrId?/:muestraEstatusId?",
        name: "PCR",
        component: () => import("../views/lab/CargaGradillas.vue"),
      },
      {
        path: "muestras-lab",
        name: "Laboratorio - Muestras",
        component: () => import("../views/lab/CargaGradillas.vue"),
      },
      {
        path: "reportes",
        name: "Reportes",
        component: () => import("../views/reportes/Reportes.vue"),
      },
      {
        path: "duplicar-cita/:citaDuplicarId",
        name: "Duplicar Cita",
        component: () => import("../views/citas/NuevaCita.vue"),
      },
      {
        path: "analytics",
        name: "Analytics",
        component: () => import("../views/analytics/Reporte.vue"),
      },
      {
        path: "promocion",
        name: "Promoción",
        component: () => import("../views/Promocion.vue"),
      },
    ],
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach(async (to, _from, next) => {
  if (to.name !== "Login" && !localStorage.getItem("jwt")) {
    next("/");
  } else if (to.name !== "Login") {
    const module = Modulos.find(
      (m) => to.fullPath.toLowerCase().indexOf(m.Router.toLowerCase()) > -1
    );
    if (!module) {
      next();
    } else {
      const permisos = JSON.parse(localStorage.getItem("modulos"));
      if (permisos.some((p) => p === module.ModuloID)) {
        next();
      } else {
        next("/");
      }
    }
  } else {
    /*else if (to.name !== 'Login') {
    try {
      const res = await validarToken();
      if (
        res.data.result !== 1 ||
        !res.data.data.Table0.length ||
        !res.data.data.Table0[0].jti
      ) {
        localStorage.removeItem('jwt');
        next('/');
      } else {
        next();
      }
    } catch (err) {
      localStorage.removeItem('jwt');
      next('/');
    }
  }*/
    next();
  }
});

export default router;
